import { api } from "@/api";
import { BettingMarketWithTranslations } from "@/types/ApiResponses/BettingMarket";

export const getBettingMarketWithTranslations = async (
  id: number
): Promise<BettingMarketWithTranslations> => {
  const res = await api.client.get(`/betting-markets-new/with-translations/${id}`);
  return res.data;
};
